.collapsed-container {
    composes: textfield-container from '../../../textfield/textfield.module.css';
    min-height: 0;
    padding: 0;
    background-color: var(--white);
    display: flex;
    flex-direction: column;
    cursor: pointer;
}

.collapsed {
    max-height: none;
    cursor: pointer;
}

.collapsed-content-row {
    display: flex;
    align-items: center;
    padding: 0 8px 0 0;
    min-height: 0;
    flex: 1;
}

.collapsed-preview {
    padding: 16px;
    font-size: var(--font-small);
    color: var(--grey);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
}

.collapsed-preview-placeholder {
    composes: collapsed-preview;
    color: var(--placeholder);
}

.note-mode {
    background-color: var(--tag-yellow-lt);
    border-radius: 8px;
}
